import { render, staticRenderFns } from "./UsersAddUser.vue?vue&type=template&id=dfcbd300&scoped=true&"
import script from "./UsersAddUser.vue?vue&type=script&lang=js&"
export * from "./UsersAddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcbd300",
  null
  
)

export default component.exports